export default class GridColumnsElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('grid-columns', GridColumnsElement);